'use strict';


var gettext = require('mag-gettext').gettext,
    graphicResolutions = [
        {value: 'tvsystem_res', name: gettext('Original video resolution')},
        {value: '720', name: '720x576'},
        {value: '1280', name: '1280x720'},
        {value: '1920', name: '1920x1080'}
    ];

module.exports = function () {
    var data = graphicResolutions.slice(0);

    switch ( core.environment.tvsystem ) {
        case 'PAL':
        case 'NTSC':
        case '576p-50':
            graphicResolutions.splice(2, 2);
            break;

        case '720p-50':
        case '720p-60':
            graphicResolutions.splice(3, 1);
            break;
    }

    return data;
};
